import { Droplet, Route, Heart, Shield, Book, Briefcase } from 'lucide-react';

const CategoryDistribution = () => {
  const categories = [
    { name: 'Water', count: 3124, icon: <Droplet className="text-blue-500" size={16} />, color: 'bg-blue-500' },
    { name: 'Roads', count: 2891, icon: <Route className="text-orange-500" size={16} />, color: 'bg-orange-500' },
    { name: 'Health', count: 1987, icon: <Heart className="text-red-500" size={16} />, color: 'bg-red-500' },
    { name: 'Security', count: 1567, icon: <Shield className="text-purple-500" size={16} />, color: 'bg-purple-500' },
    { name: 'Education', count: 1324, icon: <Book className="text-green-500" size={16} />, color: 'bg-green-500' },
    { name: 'Employment', count: 987, icon: <Briefcase className="text-yellow-500" size={16} />, color: 'bg-yellow-500' },
  ];

  const total = categories.reduce((sum, cat) => sum + cat.count, 0);

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-6">Reports by Category</h3>
      <div className="space-y-4">
        {categories.map((category) => {
          const percentage = Math.round((category.count / total) * 100);
          
          return (
            <div key={category.name} className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="p-2 bg-gray-50 rounded-lg">
                    {category.icon}
                  </div>
                  <span className="text-sm font-medium text-gray-700">{category.name}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-sm font-bold text-gray-900">{category.count.toLocaleString()}</span>
                  <span className="text-xs text-gray-500">({percentage}%)</span>
                </div>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${category.color}`}
                  style={{ width: `${percentage}%` }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryDistribution;